export default __webpack_public_path__ + "static/media/Stone _ Wood Pacific Ale - proportioned_170.7826c9a4.jpg";